class ReadMore extends HTMLElement {
  constructor() {
    super();
    this.open = false;
  }

  connectedCallback() {
    this.button = this.querySelector('[data-toggle-button]');
    this.descriptionClamp = this.querySelector('[data-description-clamp]');
    this.readMoreText = this.querySelector('[data-read-more]').innerText;
    this.readLessText = this.querySelector('[data-read-less]').innerText;

    this.button.addEventListener('click', () => this.toggle());
    this.update();
  }

  toggle() {
    this.open = !this.open;
    this.update();
  }

  update() {
    this.descriptionClamp.classList.toggle('line-clamp-3', !this.open);
    this.button.innerText = this.open ? this.readLessText : this.readMoreText;
  }
}
if (!customElements.get('read-more')) {
  customElements.define('read-more', ReadMore);
}
